export const INACTIVE_USER_TIME_THRESHOLD = 30 * 60 * 1000 // 30 minutes